import { useContext } from 'react'
import { AppFormContext } from '../context/AppFormContext'
import { CustomerCtx } from '../context/CustomerContext'
import { IdentityServerUserCtx } from '../context/IdentityServerUserContext'
import { CustomerServiceStationCtx } from '../context/ServiceStationContext'
import { MainComponentCtx } from '../context/MainComponentContext'
import { SidebarCtx } from '../context/SidebarContext'
import { CustomerLocationCtx } from '../context/FacilityContext'
import { UserCtx } from '../context/UserContext'
import { DialogContextCtx } from 'src/context/DialogContext'
import { FeatureFlagsCtx, useFeatureEnabled } from 'src/context/FeatureFlagsContext'
import { MooringsCtx } from 'src/context/MooringsContext'
import { CustomerStorageCtx } from 'src/context/StorageContext'
import { ProjectPlanningCtx } from 'src/context/ProjectPlanningContext'

export function useAppFormCtx() {
  return useContext(AppFormContext)
}

export function useIdentityServerUserCtx() {
  return useContext(IdentityServerUserCtx)
}

export function useUserCtx() {
  return useContext(UserCtx)
}

export function useLocationCtx() {
  return useContext(CustomerLocationCtx)
}

export function useServiceStationCtx() {
  return useContext(CustomerServiceStationCtx)
}

export function useStorageCtx() {
  return useContext(CustomerStorageCtx)
}

export function useProjectCtx() {
  return useContext(ProjectPlanningCtx)
}

export function useMainComponentCtx() {
  return useContext(MainComponentCtx)
}

export function useCustomerCtx() {
  return useContext(CustomerCtx)
}

export function useDialogCtx() {
  return useContext(DialogContextCtx)
}


export function useSidebarCtx() {
  return useContext(SidebarCtx)
}

export function useMooringsCtx() {
  return useContext(MooringsCtx)
}

export function useFeatureFlagsCtx() {
  return useContext(FeatureFlagsCtx)
}

export { useFeatureEnabled }